import React, { useEffect, useRef } from 'react'
import { Modal, Button } from 'antd'
import './SceneAudioPreviewModal.scss'

const SceneAudioPreviewModal = ({ visible, audioUrl, sceneTitle, onClose }) => {
  const audioRef = useRef(null)

  useEffect(() => {
    const audio = audioRef.current
    if (!audio) return

    if (!visible) {
      audio.pause()
      audio.currentTime = 0
      return
    }

    audio.load()
  }, [audioUrl, visible])

  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause()
      }
    }
  }, [])

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={520}
      centered
      destroyOnClose
      wrapClassName="scene-audio-preview-modal-wrap"
    >
      <div className="scene-audio-preview-modal">
        <div className="scene-audio-preview-modal__header">
          <h3>{sceneTitle || 'Scene'} Audio</h3>
          <p>Listen to the currently generated scene audio.</p>
        </div>

        <div
          className={`scene-audio-preview-modal__transport ${
            !audioUrl ? 'scene-audio-preview-modal__transport--empty' : ''
          }`}
        >
          {!audioUrl ? (
            <div className="scene-audio-preview-modal__empty-copy">
              No generated audio is available for this scene yet.
            </div>
          ) : (
            <audio
              ref={audioRef}
              controls
              preload="metadata"
              className="scene-audio-preview-modal__native-player"
            >
              <source src={audioUrl} />
              Your browser does not support the audio element.
            </audio>
          )}
        </div>

        <div className="scene-audio-preview-modal__footer">
          <Button onClick={onClose}>Close</Button>
        </div>
      </div>
    </Modal>
  )
}

export default SceneAudioPreviewModal
